import { render, staticRenderFns } from "./DeliveryBlockTransporterDetails.vue?vue&type=template&id=274ccf0e&"
import script from "./DeliveryBlockTransporterDetails.vue?vue&type=script&lang=js&"
export * from "./DeliveryBlockTransporterDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports